import { findWrapping, liftTarget, ReplaceAroundStep, } from 'prosemirror-transform';
import { NodeRange, Slice } from 'prosemirror-model';
// 修改自 prosemirror-commands，支持 cellSelection
export const wrapIn = (nodeType, attrs) => (state, dispatch) => {
    const { tr, selection } = state;
    let canApply = false;
    selection.ranges.forEach((_, index) => {
        const { $from, $to } = tr.selection.ranges[index];
        let bRange = $from.blockRange($to);
        if (!bRange) {
            return;
        }
        let wrapping = findWrapping(bRange, nodeType, attrs);
        while (!wrapping && (bRange === null || bRange === void 0 ? void 0 : bRange.depth)) {
            bRange = new NodeRange(bRange.$from, bRange.$to, bRange.depth - 1);
            wrapping = findWrapping(bRange, nodeType, attrs);
        }
        if (wrapping) {
            canApply = true;
            tr.wrap(bRange, wrapping);
        }
    });
    if (!canApply) {
        return false;
    }
    dispatch === null || dispatch === void 0 ? void 0 : dispatch(tr);
    return true;
};
// 修改自 lift，支持指定 nodeType
export const unWrap = (nodeType) => (state, dispatch) => {
    const { tr, selection } = state;
    let canApply = false;
    selection.ranges.forEach((_, index) => {
        const { $from, $to } = tr.selection.ranges[index];
        const arounded = aroundedNode($from, $to);
        if (arounded && arounded.type === nodeType) {
            if ($from.parent.canReplace($from.index(), $from.index(), arounded.content)) {
                canApply = true;
                tr.step(new ReplaceAroundStep($from.pos, $to.pos, $from.pos + 1, $to.pos - 1, Slice.empty, 0));
                return;
            }
        }
        let bRange = $from.blockRange($to);
        if (!bRange) {
            return;
        }
        while (bRange.parent.type !== nodeType && (bRange === null || bRange === void 0 ? void 0 : bRange.depth)) {
            bRange = new NodeRange(bRange.$from, bRange.$to, bRange.depth - 1);
        }
        if (bRange.parent.type === nodeType) {
            const target = liftTarget(bRange);
            if (target != null) {
                canApply = true;
                tr.lift(bRange, target);
            }
        }
    });
    if (!canApply) {
        return false;
    }
    dispatch === null || dispatch === void 0 ? void 0 : dispatch(tr);
    return true;
};
export function aroundedNode($from, $to) {
    if (!$from.nodeAfter || $from.nodeAfter !== $to.nodeBefore) {
        return null;
    }
    if ($from.nodeBefore === $from.nodeAfter) {
        return null;
    }
    if ($to.nodeBefore === $to.nodeAfter) {
        return null;
    }
    return $from.nodeAfter;
}
//# sourceMappingURL=wrapIn.js.map